import React from 'react';
import { Button, Tooltip } from 'antd';
import ApprovalSettings from '@components/Modals/ApprovalModal/components/ApprovalSettings';

import type { AwState } from '@components/Modals/ApprovalModal/ApprovalModal/ApprovalModal';
import type { StepItemKey } from '@components/Modals/ApprovalModal/ApprovalModal/components/Steps/Steps';

import './SettingsStep.less';

type SettingsStepProps = {
  awState: AwState;
  setAwState: (value: AwState) => void;
  onChangeStep: (value: StepItemKey) => void;
  onCloseModal: () => void;
};

export default function SettingsStep({
  awState,
  setAwState,
  onChangeStep,
  onCloseModal
}: SettingsStepProps) {
  const goNextStep = () => {
    onChangeStep('finalReview');
  };

  return (
    <div className="approval-step settings-step">
      <div className="approval-step_head">
        <h2 className="approval-step_title">
          Settings
          <Tooltip
            title={`${awState.name} approval routing`}
            placement="topLeft"
            overlayClassName="approval-modal-tooltip"
            className="approval-step_route-name"
          >
            {awState.name} approval routing
          </Tooltip>
        </h2>
        <div className="approval-step_text">
          Customize approval routing settings to fit your needs.
        </div>
      </div>
      <div className="approval-step_wrapper">
        <div className="settings-step_content tour-route-for-approval-settings">
          <ApprovalSettings
            settings={awState}
            onUpdate={(update) =>
              awState && setAwState({ ...awState, ...update })
            }
          />
        </div>
      </div>
      <div className="approval-step_buttons">
        <Button type="text" onClick={onCloseModal}>
          Cancel
        </Button>
        <Button
          type="primary"
          onClick={goNextStep}
          style={{
            minWidth: 152
          }}
        >
          Next step
        </Button>
      </div>
    </div>
  );
}
